// Date formatters shared across views. Single locale (pt-BR), no Intl —
// plain padStart keeps it tiny and deterministic.

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

// dd/mm hh:mm — compact, for recent-session lists.
export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// dd/mm/yyyy hh:mm — full, for a session's detail header.
export function formatDateTimeFull(iso: string): string {
  const d = new Date(iso);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// dd/mm/yyyy — for PR achieved dates.
export function formatDay(iso: string): string {
  const d = new Date(iso);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}
